"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyboundComponent = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _keys = require("./keys");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var CMD = 'CMD';
var CMD_REGEX = /(CMD|COMMAND|CTRL|CONTROL)/;
var SHIFT = 'SHIFT';

function buildCommandListener(component) {
  var domNode = _reactDom.default.findDOMNode(component);

  var keyboardEvents = component.keyboardEvents;
  var listenerAttached = false;

  var handler = function handler(e) {
    var selectedEvents = keyboardEvents.default;

    if ((0, _keys.hasCommandKey)(e) && (0, _keys.hasShiftKey)(e)) {
      selectedEvents = keyboardEvents.commandShift;
    } else if ((0, _keys.hasCommandKey)(e) && !(0, _keys.hasShiftKey)(e)) {
      selectedEvents = keyboardEvents.command;
    } else if ((0, _keys.hasShiftKey)(e) && !(0, _keys.hasCommandKey)(e)) {
      selectedEvents = keyboardEvents.shift;
    }

    var callback = selectedEvents[e.keyCode] || selectedEvents[e.code];

    if (callback) {
      callback(e);
    }
  };

  return {
    enable: function enable() {
      if (!listenerAttached && domNode) {
        domNode.addEventListener('keydown', handler);
        listenerAttached = true;
      }

      return this;
    },
    disable: function disable() {
      if (domNode) {
        domNode.removeEventListener('keydown', handler);
        listenerAttached = false;
        return this;
      }
    }
  };
}

var KeyboundComponent = function KeyboundComponent(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(_class, _Component);

    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_class).apply(this, arguments));
    }

    (0, _createClass2.default)(_class, [{
      key: "setUpKeyboardEvents",
      value: function setUpKeyboardEvents() {
        this.keyboardEvents = {
          command: {},
          commandShift: {},
          default: {},
          shift: {}
        };
      }
    }, {
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this.setUpKeyboardEvents();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.keyboardListener = buildCommandListener(this);
        this.keyboardListener.enable();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.keyboardListener.disable();
        this.keyboardListener = null;
      }
    }, {
      key: "_registerListener",
      value: function _registerListener(keys, callback) {
        if (typeof keys !== 'string' || typeof callback !== 'function') {
          return;
        }

        var parts = keys.toUpperCase().replace(CMD_REGEX, CMD).split('+');

        if (parts.length > 3) {
          return;
        }

        var modifiers = null;

        if (parts.indexOf(CMD) !== -1) {
          parts.splice(parts.indexOf(CMD), 1);
          modifiers = 'command';
        }

        if (parts.indexOf(SHIFT) !== -1) {
          parts.splice(parts.indexOf(SHIFT), 1);
          modifiers = modifiers ? modifiers + "Shift" : 'shift';
        }

        if (parts.length > 1) {
          return;
        }

        modifiers = modifiers || 'default';
        this.keyboardEvents[modifiers][_keys.KEYS[parts[0]]] = callback;
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return _react.default.createElement(WrappedComponent, Object.assign({}, this.props, {
          registerListener: this._registerListener.bind(this),
          ref: function ref(c) {
            return _this._c = c;
          }
        }));
      }
    }]);
    return _class;
  }(_react.Component);
};

exports.KeyboundComponent = KeyboundComponent;